import { AfterViewInit, Directive, EventEmitter, Host, HostListener, Output } from '@angular/core';

import { DziViewerComponent } from '../../dzi-viewer.component';

@Directive({
    selector: '[tsDziKeyBindings]',
    standalone: false
})
export class DziKeyBindingsDirective implements AfterViewInit {
  private _isEscapePressed = false;
  private _isSpacePressed = false;

  @Output() ctrlS = new EventEmitter<void>();
  @Output() ctrlMeta = new EventEmitter<boolean>();
  @Output() space = new EventEmitter<boolean>();
  @Output() delete = new EventEmitter<void>();
  @Output() esc = new EventEmitter<boolean>();
  @Output() leftArrow = new EventEmitter<void>();
  @Output() rightArrow = new EventEmitter<void>();

  constructor(@Host() private dziViewer: DziViewerComponent) {}

  @HostListener('document:keydown.meta.s', ['$event'])
  @HostListener('document:keydown.control.s', ['$event'])
  public onSaveShortcut(event: KeyboardEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.ctrlS.emit();
  }

  @HostListener('document:keydown.meta')
  @HostListener('document:keydown.control')
  public onMultiselectShortcutPress() {
    this.ctrlMeta.emit(true);
  }

  @HostListener('document:keydown.escape')
  public onEscape() {
    if (!this._isEscapePressed) this.esc.emit(true);
    this._isEscapePressed = true;
  }

  @HostListener('document:keydown.space')
  public onSpacePressed() {
    if (!this._isSpacePressed) this.space.emit(true);
    this._isSpacePressed = true;
  }

  @HostListener('document:keydown.delete')
  @HostListener('document:keydown.backspace')
  @HostListener('document:keydown.control.delete')
  @HostListener('document:keydown.meta.backspace')
  public onDelBackPressed() {
    this.delete.emit();
  }

  @HostListener('document:keyup.meta')
  @HostListener('document:keyup.control')
  public onMultiselectShortcutRelease(): void {
    this.ctrlMeta.emit(false);
  }

  @HostListener('document:keyup.escape')
  public onEscapeRelease() {
    this._isEscapePressed = false;
    this.esc.emit(false);
  }

  @HostListener('document:keyup.space')
  public onSpaceRelease() {
    this._isSpacePressed = false;
    this.space.emit(false);
  }

  @HostListener('document:keydown.arrowleft', ['$event'])
  public onLeftArrow(event: KeyboardEvent) {
    if (this.isInInputField(event)) return;
    event.preventDefault();
    event.stopPropagation();
    this.leftArrow.emit();
  }

  @HostListener('document:keydown.arrowright', ['$event'])
  public onRightArrow(event: KeyboardEvent) {
    if (this.isInInputField(event)) return;
    event.preventDefault();
    event.stopPropagation();
    this.rightArrow.emit();
  }

  @HostListener('document:keydown.arrowup', ['$event'])
  public onUpArrow(event: KeyboardEvent) {
    if (this.isInInputField(event)) return;
    event.preventDefault();
    event.stopPropagation();
  }

  @HostListener('document:keydown.arrowdown', ['$event'])
  public onDownArrow(event: KeyboardEvent) {
    if (this.isInInputField(event)) return;
    event.preventDefault();
    event.stopPropagation();
  }

  private isInInputField(event: KeyboardEvent): boolean {
    const target = event.target as HTMLElement;
    return (
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.contentEditable === 'true' ||
      target.classList.contains('mat-input-element')
    );
  }

  ngAfterViewInit(): void {
    if (!this.dziViewer) return;

    this.dziViewer['viewer'].addHandler('canvas-key', (event: any) => {
      if (event.originalEvent.key === 'ArrowUp' || event.originalEvent.key === 'ArrowDown') {
        if (event.originalEvent.shiftKey) return;

        event.preventVerticalPan = true;
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
      }

      if (event.originalEvent.key === 'ArrowLeft') {
        if (event.originalEvent.shiftKey) return;

        event.preventHorizontalPan = true;
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
        this.leftArrow.emit();
      }

      if (event.originalEvent.key === 'ArrowRight') {
        if (event.originalEvent.shiftKey) return;

        event.preventHorizontalPan = true;
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
        this.rightArrow.emit();
      }
    });
  }
}
